import styled from "styled-components";

import Card from "@/components/Atoms/Card";
import { FlexDiv } from "../../../../components/Atoms";

export const StyledWebinarCard = styled(Card)`
  border-radius: 8px;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
  @media only screen and (max-width: 1100px) {
    flex-direction: column;
  }
  @media only screen and (max-width: 767px) {
    margin: 0 0 24px;
    &:last-child {
      margin: 0 0;
    }
  }
`;

export const YoutubeContainer = styled(FlexDiv)`
  width: 505px;
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  .videoOverlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    &:after {
      background-color: rgba(${({ theme }) => theme.colors.shadows.black}, 0.7);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      width: 100%;
      content: "";
      pointer-events: none;
    }
  }
  @media only screen and (max-width: 1100px) {
    width: 100%;
    height: 475px;
  }
  @media only screen and (max-width: 767px) {
    height: 244px;
  }
`;

export const TextBox = styled(FlexDiv)`
  padding: 32px 48px 48px;
  flex-direction: column;
  @media only screen and (max-width: 767px) {
    padding: 16px;
  }
`;
